import React from "react";
import "./Spinner.css";

export const Spinner = () => {
  return <div className="loader"> Loading... </div>;
};

